import type { CommandHandler } from '../types';

export const salaryCalculateCommandHandler: CommandHandler = (command, context) => {
  if (!command.key) {
    return {
      success: false,
      error: 'Add Employees command is not configured.',
    };
  }

  if (!context.parentId && !context.entityId) {
    return {
      success: false,
      error: 'Save salary calculation first.',
    };
  }

  if (!context.openSalaryCalculatePicker) {
    return {
      success: false,
      error: 'Add Employees dialog is not available.',
    };
  }

  context.openSalaryCalculatePicker(command);
  return { success: true };
};
